export const UserStatus = {
  true: 'Ativo',
  false: 'Inativo'
}

export const UserStatusColors = {
  true: 'var(--success)',
  false: 'var(--danger)'
}
